import React from 'react';

interface TrashIconProps {
  color?: string;
  wSize?: string;
  hSize?: string;
}

function TrashIcon({
  color = '#d32f2f',
  wSize = '1rem',
  hSize = '1rem',
}: TrashIconProps) {
  return (
    <svg
      width={wSize}
      height={hSize}
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M7 0h6a2 2 0 0 1 2 2v1h3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-.08L17 20a2 2 0 0 1-2 2H5c-1.105 0-2-.895-1.997-1.917L2.08 9H2a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3V2a2 2 0 0 1 2-2ZM2 5h16v2H2V5Zm2.086 4h11.827l-.91 10.917L15 20H5L4.086 9ZM13 2v1H7V2h6Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default TrashIcon;
